module.exports = __webpack_public_path__ + "static/media/add.6cf4eac4.svg";